import React from "react";
import { connect } from "react-redux";
import Button from "@alboompro/boom-components/general/button";
import { PremiumCrow } from "./icons";

const UpdateButton = ({ user, text }) => {
  if (!user.upgradable) {
    return null;
  }

  return (
    <Button
      textStyle={{ color: "white" }}
      onClick={() => {
        window.open(
          "https://www.alboompro.com/pricing?utm_source=prosite&utm_campaign=custom-page-header-button#prosite",
          "_blank"
        );
      }}
    >
      <PremiumCrow /> <span style={{ marginLeft: "8px" }}>{text}</span>
    </Button>
  );
};

const mapDispatchToProps = {};

const mapStateToProps = state => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateButton);
